import { render, staticRenderFns } from "./OrgProfile.vue?vue&type=template&id=50767735&scoped=true&"
import script from "./OrgProfile.vue?vue&type=script&lang=js&"
export * from "./OrgProfile.vue?vue&type=script&lang=js&"
import style0 from "./OrgProfile.vue?vue&type=style&index=0&id=50767735&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50767735",
  null
  
)

export default component.exports